<template>
  <div class="form-group" :class="{'disabled': parseBoolean(disabled)}">
    <label :for="id" v-if="label" class="form-label">{{ label }}
      <i v-if="parseBoolean(required)" class="far fa-asterisk"></i>
      <span v-if="language" class="language"> ({{ language }})</span>
    </label>
    <input :id="id"
           ref="input"
           type="text"
           :value="value"
           :placeholder="placeholder"
           :maxlength="maxlength"
           class="form-control"
           :class="{'is-invalid': invalid}"
           :disabled="parseBoolean(disabled)"
           @input="updateValue($event.target.value);"
           @keyup="handleKeyup"
           @keydown="handleKeydown"
           @click="handleClick"
           @contextmenu="handleContextmenu"
           @focus="handleFocus"
           @blur="handleBlur"/>
    <local-errors :value="errors"/>
    <div v-if="help" class="form-text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "input-text",
  computed: {
    help: function () {
      return !!this.$slots.default;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    }
  },
  props: ["id", "value", "errors", "label", "placeholder", "language", "required", "maxlength", "disabled"],
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    },
    handleKeyup: function (event) {
      this.$emit("keyup", event);
    },
    handleKeydown: function (event) {
      this.$emit("keydown", event);
    },
    handleClick: function (event) {
      this.$emit("click", event);
    },
    handleContextmenu: function (event) {
      this.$emit("contextmenu", event);
    },
    handleFocus: function (event) {
      this.$emit("focus", event);
    },
    handleBlur: function (event) {
      this.$emit("blur", event);
    }
  }
}
</script>
